import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";

export default function useUrlTab(tabOptions: string[]) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || tabOptions[0];

  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  // Sync URL updates without losing active state
  useEffect(() => {
    if (tabFromUrl !== activeTab) setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  return { activeTab, handleTabChange };
}
